import { create } from 'zustand'
import { Locale, FiltriLocali } from '../types'
import { getLocali, getLocaliMappa, getLocaliInEvidenza, getLocaleBySlug } from '../services/locali.service'

interface LocaliState {
  locali: Locale[]
  localiMappa: Locale[]
  localiInEvidenza: Locale[]
  localeCorrente: Locale | null
  loading: boolean
  error: string | null
  filtri: FiltriLocali

  // Azioni
  fetchLocali: (filtri?: FiltriLocali) => Promise<void>
  fetchLocaliMappa: () => Promise<void>
  fetchLocaliInEvidenza: (limit?: number) => Promise<void>
  fetchLocaleBySlug: (slug: string) => Promise<Locale | null>
  setFiltri: (filtri: FiltriLocali) => void
  clearLocaleCorrente: () => void
}

export const useLocaliStore = create<LocaliState>((set) => ({
  locali: [],
  localiMappa: [],
  localiInEvidenza: [],
  localeCorrente: null,
  loading: false,
  error: null,
  filtri: {},

  fetchLocali: async (filtri) => {
    set({ loading: true, error: null })
    try {
      const locali = await getLocali(filtri)
      set({ locali, loading: false, filtri: filtri || {} })
    } catch (err: any) {
      set({ error: err.message, loading: false })
    }
  },

  fetchLocaliMappa: async () => {
    try {
      const localiMappa = await getLocaliMappa()
      set({ localiMappa })
    } catch (err: any) {
      console.error('Errore caricamento mappa:', err)
    }
  },

  fetchLocaliInEvidenza: async (limit = 6) => {
    try {
      const localiInEvidenza = await getLocaliInEvidenza(limit)
      set({ localiInEvidenza })
    } catch (err: any) {
      console.error('Errore caricamento in evidenza:', err)
    }
  },

  fetchLocaleBySlug: async (slug) => {
    set({ loading: true, error: null })
    try {
      const locale = await getLocaleBySlug(slug)
      set({ localeCorrente: locale, loading: false })
      return locale
    } catch (err: any) {
      set({ error: err.message, loading: false })
      return null
    }
  },

  setFiltri: (filtri) => {
    set({ filtri })
  },

  clearLocaleCorrente: () => {
    set({ localeCorrente: null })
  },
}))
